import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContainerModule } from '../../components/container/container.module';

import { DownloadTheAppPageComponent } from './download-the-app-page.component';
import { LoaderModule } from '../../components/loader/loader.module';

@NgModule({
    imports: [
        CommonModule,

        ContainerModule,
        LoaderModule,
    ],
    declarations: [
        DownloadTheAppPageComponent,
    ],
    exports: [
        DownloadTheAppPageComponent,
    ],
})
export class DownloadTheAppPageModule {}
